"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const links = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Teachers",
    href: "/TeachersPage"
  }, {
    label: "Retreats & Programs",
    href: "/RetreatsProgramsPage"
  }, {
    label: "Recordings",
    href: "/RecordingsPage"
  }, {
    label: "Gift of Generosity",
    href: "/GiftOfGenerosityPage"
  }, {
    label: "Contact & Donations",
    href: "Contact & Donations"
  }];
  return <footer ref={ref} className="bg-dark-background text-foreground-dark border-t border-border/20">
      <div className={`container mx-auto px-4 py-8 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="flex-shrink-0">
            <img src="/img/four_dharma_friends_logo.png" alt="Four Dharma Friends" className="h-7" />
          </div>

          {}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {links.map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-sm text-foreground-dark/80 hover:text-foreground-dark transition-all duration-200 hover:underline underline-offset-4 decoration-primary">
                {link.label}
              </Link>)}
          </nav>
        </div>

        {}
        <div className="mt-6 pt-4 border-t border-border/10 text-center">
          <p className="text-xs text-foreground-dark/60">
            © {new Date().getFullYear()} Four Dharma Friends. All teachings
            offered freely under dana tradition.
          </p>
        </div>
      </div>
    </footer>;
}